export { default } from './OpenQuestionContainer';
